import React from "react";
import styles from "./heading.module.scss"

interface IProps{
    heading:string;
    subheading?:string;
    headingClassname?:string;
    subheadingClassname?:string;
}

const Heading=({heading,subheading,headingClassname,subheadingClassname}:IProps)=>{
    return(
        <div className={styles["wrapper"]}>
            <h2 className={`${styles["heading"]} ${headingClassname ?? ""}`}>{heading}</h2>
            <p className={`${styles["subheading"]} ${subheadingClassname ??''}` }>{subheading}</p>
        </div>
        )
}
export default Heading;